import { Box, Grid, Toolbar, Typography } from "@mui/material"
import React, { useContext } from "react"
import { customPalette, theme } from "../../../../theme"
import { BSVariantContext } from "../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { BSBuildingContext } from "../../../pages/projects/project/beem-shot/variant/building/components/context/BSBuildingContext"
import { BackButtonNavbar } from "../../buttons/back-button/BackButtonNavbar"
import "../app-navbar-v2.scss"

export function HeaderWithoutStep(): React.JSX.Element {
  const { selectedVariant } = useContext(BSVariantContext)
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  return (
    <Toolbar
      sx={{
        color: "white",
        borderRadius: 5,
        backgroundColor: customPalette.dark1,
        ...theme.mixins.toolbar,
      }}>
      <Grid container display="flex" justifyContent="space-between" alignContent="center">
        <Grid item xs={3} display="flex" flexDirection="row" alignItems="center">
          <BackButtonNavbar />

          <Box display="flex" flexDirection="column">
            <Typography fontSize={11} fontWeight={400}>
              {`${selectedVariant?.name} /`}
            </Typography>
            <Typography fontSize={16} fontWeight={600}>
              {`${selectedBSBuilding?.name ?? "Nouveau batiment"}`}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={7} />
        <Grid item xs={2} />
      </Grid>
    </Toolbar>
  )
}
